import BarChartComponent from '@/components/ui/charts/BarChartComponent';
import { useMemo } from 'react';

export type WeeklyConsultationsBySpecialtyProps = {
    data: Array<{ day: string, specialty: string, count: number }>;
    title: string;
}

function WeeklyConsultationsBySpecialtyComponent(props: WeeklyConsultationsBySpecialtyProps) {
    const { data, title } = props;

    const specialties = useMemo(() => [...new Set(data.map(item => item.specialty))], [data]);
    const transformedData = useMemo(() => specialties.map(specialty => ({
        label: specialty,
        values: data.filter(item => item.specialty === specialty).map(item => ({ subLabel: item.day, value: item.count }))
    })), [data, specialties]);

    return <BarChartComponent data={transformedData} title={`${title}`} />;
}

export default WeeklyConsultationsBySpecialtyComponent;
